import React, { useCallback, useState } from 'react'

import PropTypes from 'prop-types'

import { Container } from './styles'
import { FiXCircle } from 'react-icons/fi'

const Message = ({ type, title, closable = false, children: content, style, className }) => {
  const [isVisible, setIsVisible] = useState(true)

  const handleClose = useCallback(
    () => {
      setIsVisible(false)
    }, []
  )

  return (
    isVisible && (
      <Container
        type={type}
        $hasDescription={Boolean(content)}
        style={style}
        className={className}
      >
        <div className="message__content">
          {title && <h4>{title}</h4>}

          {content && <p>{content}</p>}
        </div>

        {closable && (
          <button
            className="message__close"
            type="button"
            onClick={handleClose}
          >
            <FiXCircle size={18} />
          </button>
        )}
      </Container>
    )
  )
}

Message.propTypes = {
  className: PropTypes.any,
  type: PropTypes.string.isRequired,
  title: PropTypes.string,
  closable: PropTypes.bool,
  children: PropTypes.any,
  style: PropTypes.object
}

export default Message
